import { render, staticRenderFns } from "./firstuse.vue?vue&type=template&id=71a1352b&scoped=true&"
import script from "./firstuse.vue?vue&type=script&lang=js&"
export * from "./firstuse.vue?vue&type=script&lang=js&"
import style0 from "./firstuse.vue?vue&type=style&index=0&id=71a1352b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a1352b",
  null
  
)

export default component.exports